<script>
import {getCardBackgroundColor} from "../../helpers/colorHelper";

export default {
name: "housePricelist",
  data() {
    return {
      isExpanded: this.defaultExpanded,
      isFirstRow: true,
    }
  },
  methods: {
    getCardBackgroundColor,
    numberWithCommas(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
    },
    getPrice(minPrice, maxPrice) {
      let price = "";

      if (
        (minPrice == null || minPrice == 0) &&
        (maxPrice == null || maxPrice == 0)
      ) {
        price = "Make Offer"; //no price
      } else if (minPrice && maxPrice && minPrice == maxPrice) {
        price = "$" + this.numberWithCommas(minPrice); //fixed price
      } else if (minPrice && (maxPrice == null || maxPrice == 0)) {
        price = "$" + this.numberWithCommas(minPrice); //fixed price
      } else if (minPrice && maxPrice) {
        price =
          "$" +
          this.numberWithCommas(minPrice) +
          " - $" +
          this.numberWithCommas(maxPrice); //ranged
      }
      return price;
    },
    getPriceCommon(minPrice, maxPrice = null) {
      minPrice = minPrice || 0;
      maxPrice = maxPrice || 0;

      if (minPrice === 0 && maxPrice === 0) {
        return "TBA";
      }

      if (minPrice === 0 && maxPrice > 0) {
        return "$" + this.numberWithCommas(maxPrice);
      }

      if (maxPrice === 0 || minPrice === maxPrice) {
        return "$" + this.numberWithCommas(minPrice);
      }

      return "$" + this.numberWithCommas(minPrice) + " - $" + this.numberWithCommas(maxPrice);
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  },
  props: {
    property: {},
    defaultExpanded: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<template>
  <el-card class="expandable-card" :style="{ backgroundColor: getCardBackgroundColor(property.status) }">
    <!-- Header Section -->
    <div class="header-section" :style="{ backgroundColor: getCardBackgroundColor(property.status) }" @click="toggleExpand">
      <div class="header-grid" :style="{ backgroundColor: getCardBackgroundColor(property.status) }">
        <div class="header-item">
          <span class="label">Residence</span>
          <span class="value">{{ property.apt }}</span>
        </div>
        <div class="header-item">
          <span class="label">Status</span>
          <span class="value">{{ property.status }}</span>
        </div>
        <div class="header-item">
          <span class="label">Beds</span>
          <span class="value">{{ property.beds }}</span>
        </div>
        <div class="header-item">
          <span class="label">Baths</span>
          <span class="value">{{ property.baths }}</span>
        </div>
        <i :class="['el-icon-arrow-right', { 'is-active': isExpanded }]"></i>
      </div>
    </div>

    <!-- Expanded Content -->
    <div class="expanded-content" v-show="isExpanded">
      <!-- First Section -->
      <div class="content-section">
        <div class="content-grid">
          <div class="content-item">
            <span class="label">Cars</span>
            <span class="value">{{ property.cars }}</span>
          </div>
          <div class="content-item">
            <span class="label">Land m<sup>2</sup></span>
            <span class="value">{{ property.landm2 }}</span>
          </div>
          <div class="content-item">
            <span class="label">Internal m<sup>2</sup></span>
            <span class="value">{{ property.internal }}</span>
          </div>
          <div class="content-item">
            <span class="label">Alfresco m<sup>2</sup></span>
            <span class="value">{{ property.balcony }}</span>
          </div>
          <div class="content-item">
            <span class="label">Total m<sup>2</sup></span>
            <span class="value">{{ property.total }}</span>
          </div>
        </div>
      </div>

      <!-- Second Section -->
      <div class="content-section">
        <div class="content-grid-three">
          <div class="content-item">
            <span class="label">Price</span>
            <span class="value">{{ getPrice(property.totalPrice, property.totalPriceMax) }}</span>
          </div>
          <div class="content-item">
            <span class="label">Est. Rental (pw)</span>
            <span class="value">{{ getPriceCommon(property.anticipatedRent, property.anticipatedRentMax) }}</span>
          </div>
          <div class="content-item">
            <span class="label">Floorplan</span>
            <el-image
              v-if="property.floorPlansUrl"
              :preview-src-list="[property.floorPlansUrl]"
              :src="require('../../assets/u1.png')"
              style="display: inline-block; margin-left: auto; margin-right: auto; max-height: 40px;"
            />
            <span class="value" v-else>N/A</span>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<style scoped lang="scss">

.el-card /deep/ .el-card__body {
/*  padding: 0 10px !important;*/
}

.expandable-card {
  margin: 10px;
  /*background-color: rgba(204, 204, 204, 0.1);*/
  border-radius: 10px;

  .header-section {
    cursor: pointer;
    /*background-color: rgba(204, 204, 204, 0.1);*/

    &:hover {
      background-color: #ffffff;
    }
  }

  .header-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr) 15px;
    gap: 5px;
    align-items: center;
    padding: 5px 0;
    position: relative;
    /*background-color: rgba(204, 204, 204, 0.1);*/
  }

  .header-item, .content-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;

    .label {
      color: #003333;
      font-size: 13px;
      font-weight: 600;
      width: max-content;
    }

    .value {
      color: #003333;
      font-size: 12px;
      font-weight: 600;
      width: max-content;
    }
  }

  .el-icon-arrow-right {
    transition: transform 0.3s;
    font-size: 16px;
    color: #003333;

    &.is-active {
      transform: rotate(90deg);
    }
  }

  .expanded-content {
    margin-top: 16px;
    /*border-top: 1px solid #ebeef5;*/
  }

  .content-section {
    padding: 5px 0;

    &:not(:last-child) {
      /*border-bottom: 1px solid #ebeef5;*/
    }
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #003333;
    margin-bottom: 12px;
  }

  .content-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 5px;
  }

  .content-grid-three {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
  }
}
.header-item  {
  .el-divider--vertical {
    height: 100% !important;
  }
}
.content-item  {
  .el-divider--vertical {
    height: 100% !important;
  }
}

.expandable-card /deep/ .header-section {
  /*background-color: #ffffff !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/housePricelist.vue